import React, { useEffect, useState } from 'react';
//redux
import { get, isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import {
  listClassMaterial,
  listClassMaterialDetails,
} from '../../../../actions/classMaterialsActions';
import { dateFormat } from '../../../../api/dateFormat';
//material imports
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
//components
import CardLayout from '../../../../components/DataTextCard/Layout';
import PageHeading from '../../../../components/PageHeading';
import { Tab, Tabs } from '@material-ui/core';
import NoData from '../../../../components/NoData';
import LoadingSkeleton from '../../../../components/LoadingSkeleton';
import Skeleton from '@material-ui/lab/Skeleton';

export default function ClassMaterialLayout() {
  // State
  const [uniqueCode, setUniqueCode] = useState(0);
  const [value, setValue] = React.useState(0);
  const [isFetching, setIsFetching] = useState(false);
  const [isFetchingDetails, setIsFetchingDetails] = useState(false);

  // Redux
  const dispatch = useDispatch();
  const loginData = useSelector((state) =>
    get(state, 'loginReducer.data.jwt', {})
  );
  const classMaterialArray = useSelector((state) =>
    get(state, 'classMaterialReducer.data.listClass', [])
  );
  const classMaterialDetails = useSelector((state) =>
    get(state, 'classMaterialReducer.classMaterialDetails.listNotes', [])
  );
  const errorMessage = useSelector((state) =>
    get(state, 'classMaterialReducer.errorMessage', '')
  );

  //functions

  useEffect(() => {
    setIsFetching(true);
    listClassMaterial(loginData, dispatch).then(() => {
      setIsFetching(false);
    });
  }, []);

  useEffect(() => {
    if (uniqueCode !== 0) {
      setIsFetchingDetails(true);
      listClassMaterialDetails(uniqueCode, loginData, dispatch).then(() => {
        setIsFetchingDetails(false);
      });
    }
  }, [uniqueCode]);

  const handleUniqueCode = (code) => {
    setUniqueCode(code);
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const subjects = Object.keys(
    !isEmpty(classMaterialArray) &&
      classMaterialArray.length > 0 &&
      classMaterialArray.reduce((c, e) => {
        if (!c[e.SubjectName]) c[e.SubjectName] = e;
        return c;
      }, {})
  );

  //Class Material Detail Data
  const dataList = () => {
    const array = isFetchingDetails
      ? [1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
      : classMaterialDetails;
    const list = [];
    array.map((data, index) => {
      list.push(
        <a
          href={!isFetchingDetails && data.Value}
          target="_blank"
          rel="noopener noreferrer"
          download
          key={index}
        >
          <ListItem button>
            {isFetchingDetails ? (
              <Skeleton width="100%" />
            ) : (
              <>
                <ListItemText primary={data.Text} />
                <span className="icon-view">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 50 50"
                    fill="currentColor"
                    width="20"
                  >
                    <path d="M47.81,24.09c-.41-.46-10.35-11.3-22.81-11.3S2.6,23.63,2.19,24.09a1.35,1.35,0,0,0,0,1.82c.41.46,10.35,11.3,22.81,11.3s22.4-10.84,22.81-11.3A1.35,1.35,0,0,0,47.81,24.09ZM25,34.5A9.5,9.5,0,1,1,34.5,25,9.51,9.51,0,0,1,25,34.5Z" />
                    <path d="M26.36,22.29A4,4,0,0,1,28.07,19a6.78,6.78,0,1,0,3.6,7.16A4,4,0,0,1,26.36,22.29Z" />
                  </svg>
                </span>
              </>
            )}
          </ListItem>
        </a>
      );
    });
    return list;
  };

  const populateClassMaterialList = () => {
    let list = [];
    let tabLabels = [];

    if (!isEmpty(subjects)) {
      subjects.map((data, index) => {
        tabLabels.push(
          <Tab label={data.toUpperCase()} tabIndex={index} key={index} />
        );
      });

      subjects.map((data, index) => {
        let classList = [];
        classMaterialArray.map((classesData, classIndex) => {
          let key = `${index}${classIndex}`;
          if (classesData.SubjectName === data) {
            classList.push(
              <div
                key={key}
                topic={classesData.ClassTitle}
                date={dateFormat(classesData.ClassDate)}
                uniqueCode={classesData.UniqueCode}
                handler={() => {
                  handleUniqueCode(classesData.UniqueCode);
                }}
                list={dataList()}
                headerText={'Class Material'}
              />
            );
          }
        });
        return list.push(
          <CardLayout subject={data} key={index} value={value} index={index}>
            {classList}
          </CardLayout>
        );
      });
    }
    return (
      <React.Fragment>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          className="line-tab"
        >
          {tabLabels}
        </Tabs>
        {list}
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <PageHeading titlePrimary="Digital Class" titleSecondary="Material" />
      {isFetching ? (
        <>
          <LoadingSkeleton type="smallcardlist" />
          <LoadingSkeleton type="smallcardlist" />
        </>
      ) : !isEmpty(
          populateClassMaterialList().props.children[0].props.children
        ) ? (
        populateClassMaterialList()
      ) : (
        <NoData
          message={
            !isEmpty(errorMessage)
              ? errorMessage
              : 'As of now,No class Material is available for your Batch. Please come back later.'
          }
        />
      )}
    </React.Fragment>
  );
}
